import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    root: {
        padding: ".625rem 1rem",
        borderRadius: ".75rem",
        background: theme.palette.tailwind.slate[50],
        color: theme.palette.tailwind.slate[500],
        "@media print": {
            paddingInline: 0,
            background: "none",
        },
    },
    label: {
        fontWeight: 700,
        textTransform: "uppercase",
    },
    room: {
        width: "12rem",
        flexShrink: 0,
    },
    columns: {
        flex: 1,
        minWidth: 0,
        paddingInline: "1rem",
    },
    time: {
        width: "9rem",
        flexShrink: 0,
    },
    meeting: {
        flex: 1,
        minWidth: 0,
    },
    attendees: {
        minWidth: "5rem",
        flexShrink: 0,
        textAlign: "right",
    },
    duration: {
        width: "6rem",
        flexShrink: 0,
    },
}))

export function MeetingRoomsRoomGroupsHeader() {
    const { classes, cx } = useStyles()

    return (
        <Stack direction="row" spacing="1.5rem" className={classes.root}>
            <LocalizedStrict id="service-center-meeting-rooms-group-room-column-room">
                <Typography variant="caption" className={cx(classes.label, classes.room)}>
                    Room
                </Typography>
            </LocalizedStrict>
            <Stack direction="row" spacing="1rem" className={classes.columns}>
                <LocalizedStrict id="service-center-meeting-rooms-group-room-column-time">
                    <Typography variant="caption" className={cx(classes.label, classes.time)}>
                        Time
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict id="service-center-meeting-rooms-group-room-column-meeting">
                    <Typography variant="caption" className={cx(classes.label, classes.meeting)}>
                        Meeting
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict id="service-center-meeting-rooms-group-room-column-duration">
                    <Typography variant="caption" className={cx(classes.label, classes.duration)}>
                        Duration
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict id="service-center-meeting-rooms-group-room-column-attendees">
                    <Typography variant="caption" className={cx(classes.label, classes.attendees)}>
                        Attendees
                    </Typography>
                </LocalizedStrict>
            </Stack>
        </Stack>
    )
}
